import type { FaireProductEntity } from "../../entity_types/product";

export const p_ffm733ehvy: FaireProductEntity = {
  token: "p_ffm733ehvy",
  type: "product",
  name: "Rhinestone Pave Heart Evil Eye Earrings",
  brandToken: "b_c3xmn96nkh",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/8cf7f66ba75fb41c62997920627bdbdb4ad1daab5693e1c58cc0f1bfeb00e874.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ba9349dcca545757fb3f9bcdfdac6774003e8583e1ef8fadac36a5a9167796e2.jpeg",
    "https://cdn.faire.com/fastly/4972c6c3578b0858ca881082793329fead90c7b1cdbb50cb6e22d2c2b76b6a21.jpeg",
    "https://cdn.faire.com/fastly/76ddc2e9963cf2edc21bbfd46d2d221b089f392e9a8c0aa5959738d0a89cb60a.jpeg",
    "https://cdn.faire.com/fastly/725c7be1c428a7ff9e81397a4d25064a5b8e4a8fce8aa8b457a4e5fa8d0e5d09.jpeg",
    "https://cdn.faire.com/fastly/b565829c283c601c43025939a37c15df5c94a2f45ed46c22b0866ddd578de029.jpeg",
  ],
  priceDollars: 5.72,
  description:
    'Size : 1" X 1"\r\nPost Back\r\nEye-catching heart-shaped stud earrings featuring a bold evil eye design with layered detailing that adds instant personality to any look. Perfect for boutiques seeking statement accessories that blend symbolism with trend-forward style, ideal for gifting, festivals, and everyday standout wear.\nLead and Nickel Compliant\n',
  tags: [],
  msrpDollars: 11.45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:07.342Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
